{
    let expire = 5 * 60 * 1000;
    let result = null;

    const localResult = () => {
        let result = [
            {
                "_id": "5eccece6bf33f3279f9740ce",
                "text": "適逢中秋連假，雲端學院將配合政府於9.1-9.20進行休假，期間完成之訂單將於開始上班日後陸續出貨，如有任何問題請利用線上留言，我們將會陸續",
                "startDate": 1590545160000,
                "status": "secondary",
                "btnText": "測試一下",
                "btnHref": "https://www.ehanlin.com.tw",
                "endDate": 1600991700000
            },
            {
                "_id": "5eccee8156570130f8310ef3",
                "enabled": true,
                "text": "因應109上課程上線，雲端學院將於7.20中午12:00進行升級，期間將無法使用，敬請見諒！",
                "startDate": 1590545160000,
                "status": "primary",
                "btnHref": null,
                "btnText": null,
                "endDate": 1599882900000
            },
            {
                "_id": "5ecde7ef1988d6241cf2f321",
                "status": "simple",
                "text": "1234",
                "btnText": "1234",
                "startDate": 1590552540000,
                "endDate": 1601666100000
            },
            {
                "_id": "5c332bcb6c928b1f748d1bbc",
                "app": "magic0",
                "backgroundColor": "#f598be",
                "endDate": 1735660800000,
                "startDate": 1577239380000,
                "text": "恭喜 阿Ｏ0Ｏ 同學開啟 Lv6 藥水，獲得 防彈少年團指環扣  寶石 101、e幣 1072",
                "type": "event",
                "enabled": true,
                "priority": 2,
                "status": "secondary",
                "btnHref": "https://www.ehanlin.com.tw",
                "btnText": "測試測試"
            }
        ];

        return new Promise((resolve, reject) => {
            let update = () => {
                dispatchEvent(new Event("data-change"));
                setTimeout(update, expire);
                resolve(result);
            }
            update();
        });
    };

    const wwwResult = () => {
        return new Promise((resolve, reject) => {
            let update = () => {
                fetch('/Marquee')
                    .then((response) => response.json())
                    .then((result) => {
                        dispatchEvent(new Event("data-change"));
                        setTimeout(update, expire);
                        resolve(result);
                    })
            }

            update();
        });
    };

    // 以下為和主要邏輯無關的工具類
    const listeners = [];
    const addEventListener = (type, callback) => {
        if (!(type in listeners)) {
            listeners[type] = [];
        }
        listeners[type].push(callback);
    };
    const dispatchEvent = (event) => {
        if (!(event.type in listeners)) {
            return true;
        }
        let stack = listeners[event.type];
        event.target = result;
        for (let i = 0; i < stack.length; i++) {
            stack[i].call(result, event);
        }
        return !event.defaultPrevented;
    };

    // 開放給頁面使用的介面
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {};
    }

    if(window.eHanlin.dataprovider === undefined || window.eHanlin.dataprovider === null){
        window.eHanlin.dataprovider = {};
    }

    window.eHanlin.dataprovider.marquee = {
        get data() {
            if(result === null){
                result = window.location.protocol.toLowerCase() === 'file:' ||
                window.location.hostname === 'localhost' ? localResult() : wwwResult();
            }
            return result;
        },
        // Event("data-change") 當 data 改變時，預設頻率一小時一次，可透過設定 expire 改變
        addEventListener : addEventListener,
        // 設定資料過期時間，記得要在 get date() 前設，不然第一次過期會是一小時後
        set expire(v) {
            expire = v;
        },
        get expire() {
            return expire;
        }
    };
}